import { ImpersonationUrlHandler } from '../../src/zportiAdmin/components/ImpersonationUrlHandler/ImpersonationUrlHandler'

export default function ImpersonateRoute() {
  return <ImpersonationUrlHandler />
}
